/** Giriş kuralları (erp rules.ts girisiDegerlendir'den). Veri erişimi yok, saf fonksiyon. */
export const MAKS_BASARISIZ_GIRIS = 5;
export const KILIT_SURESI_DK = 15;
export const OTURUM_OMRU_GUN = 90;
export const ROLLER = [
    "pm", "kalite_lideri", "saha_inspektoru", "formen", "test_teknisyeni", "saha_supervizoru", "sistem_yoneticisi",
];
/**
 * Rol etiketi YALNIZ GÖSTERİM içindir; mantık her yerde `rol` koduyla kurulur. Buradaki metin
 * hem web'de hem API yanıtında (`rolEtiket`) geçer ve arayüzde `cevir()` ile Türkçeleşir.
 * 03.09 çeviri turunda ikisi (Kalite Lideri, Test Teknisyeni) Türkçe kalmıştı.
 */
export const ROL_ETIKET = {
    pm: "Project Manager",
    kalite_lideri: "Quality Lead",
    saha_inspektoru: "Field Inspector",
    formen: "Foreman / Welding",
    test_teknisyeni: "Test Technician",
    saha_supervizoru: "Field Supervisor",
    sistem_yoneticisi: "System Administrator",
};
/** PM süper kullanıcı (03- §2) + sistem yöneticisi: kullanıcı ve kütük yönetimi. */
export function yoneticiMi(rol) {
    return rol === "pm" || rol === "sistem_yoneticisi";
}
export function girisiDegerlendir(b) {
    const red = (mesaj, kilitlenmeliMi = false) => ({ ok: false, mesaj, kilitlenmeliMi });
    const k = b.kullanici;
    // Kullanıcı yoksa da parola yanlışsa da AYNI mesaj: kayıtlı adresleri sızdırma.
    if (!k)
        return red("E-mail or password is incorrect.");
    if (k.kilitliAt && k.kilitliAt.getTime() > b.simdi.getTime()) {
        const kalan = Math.ceil((k.kilitliAt.getTime() - b.simdi.getTime()) / 60_000);
        return red(`Too many failed attempts. ${kalan} minutes.`);
    }
    if (!b.parolaDogru)
        return red("E-mail or password is incorrect.", k.basarisizGirisSayisi + 1 >= MAKS_BASARISIZ_GIRIS);
    // Kimliğini ispatlamış kişiye "hesabın kapalı" demek bilgi sızdırmaz.
    if (!k.aktif)
        return red("Your account has been closed. Contact your administrator.");
    return { ok: true };
}
//# sourceMappingURL=giris.js.map